import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LogInPageComponent } from './page/log-in-page/log-in-page.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpLogInPageComponent } from './page/otp-log-in-page/otp-log-in-page.component';
import { CoreModule, LoaderInterceptor } from 'src/app/core/core.module';
import { environment } from 'src/environments/environment';
import { NgOtpInputModule } from 'ng-otp-input';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TotpVerifyComponent } from './page/totp-verify/totp-verify.component';


@NgModule({
  declarations: [
    LogInPageComponent,
    OtpLogInPageComponent,
    TotpVerifyComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule,
    NgOtpInputModule,
    CoreModule.forRoot(environment)
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ]
})
export class LoginModule { }
